
import { ref } from 'vue'

// Globální stav toastů
const toasts = ref([])

// Counter pro unikátní ID
let toastIdCounter = 0

const useToast = () => {
  const showToast = (type, title, message, duration = 4000) => {
    const toast = {
      id: ++toastIdCounter,
      type,
      title,
      message,
      timestamp: new Date()
    }

    toasts.value.push(toast)

    // Automatické odstranění
    setTimeout(() => {
      removeToast(toast.id)
    }, duration)

    return toast.id
  }

  const removeToast = (id) => {
    const index = toasts.value.findIndex(toast => toast.id === id)
    if (index > -1) {
      toasts.value.splice(index, 1)
    }
  }

  const success = (title, message, duration = 4000) => {
    return showToast('success', title, message, duration)
  }

  const error = (title, message, duration = 5000) => {
    return showToast('error', title, message, duration)
  }

  const warning = (title, message, duration = 4000) => {
    return showToast('warning', title, message, duration)
  }

  const info = (title, message, duration = 4000) => {
    return showToast('info', title, message, duration)
  }

  const clear = () => {
    toasts.value = []
  }

  return {
    toasts,
    showToast,
    removeToast,
    success,
    error,
    warning,
    info,
    clear
  }
}

export default useToast
